const cfg = {
  path: {
    home: '/',
    i: '/i',
    app: '/app/:id',
    fee: '/fee',
    unpayList: '/fee/unpay',
    serviceFeeList: '/fee/service',
    installFeeList: '/fee/install',
    protocols: '/protocols'
  },
}

export function fillPathAppId(path, id) {
  return path.replace(':id', id)
}

export default cfg